import React from "react";
import PlanetCard from "./planetCard";
import HouseCard from "./houseCard";
import BirthChart3D from "./BirthChart3D";
import FutureInterpretation from "./FutureInterpretation";
import { FiChevronDown } from "react-icons/fi";
import {
  GiAries,
  GiTaurus,
  GiGemini,
  GiCancer,
  GiLeo,
  GiVirgo,
  GiLibra,
  GiScorpio,
  GiSagittarius,
  GiCapricorn,
  GiAquarius,
  GiPisces,
} from "react-icons/gi";

// ===== VERİ İŞLEME FONKSİYONLARI =====

// Gezegen verilerini işleyen fonksiyonlar
export const getPlanetsData = (birthChartData) => {
  if (!birthChartData?.planets || !Array.isArray(birthChartData.planets)) {
    return [];
  }

  const planetMapping = {
    "Sun": { name: "Güneş", icon: "/assets/planetImages/Gunes.png" },
    "Moon": { name: "Ay", icon: "/assets/planetImages/Ay.png" },
    "Mercury": { name: "Merkür", icon: "/assets/planetImages/Merkur.png" },
    "Venus": { name: "Venüs", icon: "/assets/planetImages/Venus.png" },
    "Mars": { name: "Mars", icon: "/assets/planetImages/Mars.png" },
    "Jupiter": { name: "Jüpiter", icon: "/assets/planetImages/Venus.png" },
    "Saturn": { name: "Satürn", icon: "/assets/planetImages/Satürn.png" },
    "Uranus": { name: "Uranüs", icon: "/assets/planetImages/Uranus.png" },
    "Neptune": { name: "Neptün", icon: "/assets/planetImages/Neptun.png" },
    "Pluto": { name: "Plüton", icon: "/assets/planetImages/Gunes.png" }
  };

  return birthChartData.planets.map((planet) => {
    const mapping = planetMapping[planet.planet_name];
    if (!mapping) return null;

    return {
      name: mapping.name,
      degree: parseFloat(planet.degree).toFixed(1),
      degree_formatted: planet.degree_formatted || `${parseFloat(planet.degree).toFixed(1)}°`,
      icon: mapping.icon,
      zodiac: planet.zodiac_sign,
      house: planet.house_number,
      symbol: planet.planet_symbol,
      description: planet.description,
      meaning: planet.meaning,
      retrograde: planet.retrograde || false
    };
  }).filter(Boolean);
};

// Ev verilerini işleyen fonksiyonlar
export const getHousesData = (birthChartData) => {
  if (!birthChartData?.houses || !Array.isArray(birthChartData.houses)) {
    return [];
  }

  return birthChartData.houses.map((house) => {
    return {
      name: `${house.house_number}. Ev`,
      degree: parseFloat(house.start_degree).toFixed(1),
      degree_formatted: house.start_degree_formatted || `${parseFloat(house.start_degree).toFixed(1)}°`,
      icon: `/assets/planetImages/Ev${house.house_number}.png`,
      zodiac: house.zodiac_sign,
      symbol: house.zodiac_symbol,
      houseName: house.house_name,
      planets: house.planets_in_house || [],
      description: house.description,
      endDegree: parseFloat(house.end_degree).toFixed(1)
    };
  });
};

// Burç ikonları mapping'i
export const zodiacIconMap = {
  "Koç": GiAries, Aries: GiAries,
  "Boğa": GiTaurus, Taurus: GiTaurus,
  "İkizler": GiGemini, Gemini: GiGemini,
  "Yengeç": GiCancer, Cancer: GiCancer,
  "Aslan": GiLeo, Leo: GiLeo,
  "Başak": GiVirgo, Virgo: GiVirgo,
  "Terazi": GiLibra, Libra: GiLibra,
  "Akrep": GiScorpio, Scorpio: GiScorpio,
  "Yay": GiSagittarius, Sagittarius: GiSagittarius,
  "Oğlak": GiCapricorn, Capricorn: GiCapricorn,
  "Kova": GiAquarius, Aquarius: GiAquarius,
  "Balık": GiPisces, Pisces: GiPisces,
};

// ===== BİLEŞENLER =====

// Sekme Bileşenleri
export const TabButton = ({ isActive, onClick, children }) => {
  return (
    <button
      className={`px-3 py-1 flex-1 min-w-0 truncate font-semibold font-poppins rounded-lg transition text-[11px] ${isActive
        ? "bg-[#D0E1E4] text-[#3DA7B5]"
        : " text-[#90908D] opacity-80"
        }`}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export const MainTabButton = ({ isActive, onClick, children, className = "" }) => {
  return (
    <button
      className={`py-2 text-xs w-full font-medium transition-colors ${isActive
        ? "text-[#3DA7B5] border-b-2 border-[#3DA7B5]"
        : "text-black/50 hover:text-black/70"
        } ${className}`}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export const TabContainer = ({ children }) => {
  return (
    <div className="flex gap-2 justify-start items-center mb-4">
      {children}
    </div>
  );
};

export const MainTabContainer = ({ children }) => {
  return (
    <div className="flex items-center justify-center border-b border-[#3DA7B5]/30 px-1">
      {children}
    </div>
  );
};

// Gezegen Listesi Bileşeni
export const PlanetList = ({ planets }) => {
  if (planets.length === 0) {
    return (
      <div className="text-start py-8">
        <p className="text-black/80 text-sm">Gezegen verileri yükleniyor...</p>
        <p className="text-black/60 text-xs mt-2">API'den veri gelmediğinde bu mesaj görünür</p>
      </div>
    );
  }

  return (
    <div className="bg-[#FFFFFF4D] rounded-lg border border-[#FFFFFF4D]">
      {planets.map((planet, index) => (
        <PlanetCard
          key={index}
          name={planet.name}
          degree={planet.degree}
          icon={planet.icon}
          planets={planet}
        />
      ))}
    </div>
  );
};

// Ev Listesi Bileşeni
export const HouseList = ({ houses, onHouseClick }) => {
  if (houses.length === 0) {
    return (
      <div className="text-left py-8">
        <p className="text-black/80 text-sm">Ev verileri yükleniyor...</p>
        <p className="text-black/60 text-xs mt-2">API'den veri gelmediğinde bu mesaj görünür</p>
      </div>
    );
  }

  return (
    <>
      {houses.map((house, index) => (
        <HouseCard
          key={index}
          name={house.name}
          degree={house.degree}
          icon={house.icon}
          house={house}
          onHouseClick={onHouseClick}
        />
      ))}
    </>
  );
};

// Ev Modal Bileşeni
export const HouseModal = ({ isOpen, onClose, selectedHouse }) => {
  if (!isOpen || !selectedHouse) return null;

  const Icon = zodiacIconMap[selectedHouse?.zodiac] || null;
  const planetsInHouse = selectedHouse?.planets || [];
  const title = planetsInHouse.length > 0
    ? `${planetsInHouse[0]?.name || ""} ${selectedHouse.name}`
    : `${selectedHouse.name}`;
  const description = selectedHouse?.description || "";

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-white/10 backdrop-blur-md" onClick={onClose} />
      <div className="relative z-10 w-[92%] max-w-[360px] bg-white rounded-2xl shadow-2xl p-5">
        <button
          aria-label="Kapat"
          className="absolute top-3 right-3 text-[#3DA7B5] text-xl"
          onClick={onClose}
        >
          ×
        </button>
        <div className="flex flex-col gap-3">
          <div className="mx-auto w-24 h-24 rounded-full shadow-lg flex items-center justify-center">
            {Icon && <Icon className="text-[#3F414E]" size={38} />}
          </div>
          <div className="text-black font-semibold text-base">{title}</div>
          <div className="text-black/60 text-xs">{selectedHouse?.degree}° • {selectedHouse?.zodiac}</div>
          {description && <p className="text-black/70 text-sm leading-5">{description}</p>}
        </div>
      </div>
    </div>
  );
};

// Doğum Haritası Bileşeni
export const BirthChartComponent = ({ frontendChart, birthChartData }) => {
  return (
    <div className="flex flex-col items-center justify-center">
      {/* 3D Harita */}
      <BirthChart3D birthChartData={birthChartData} frontendChart={frontendChart} />
    </div>
  );
};

// Gelecek Yorumlama Bileşeni
export const FutureInterpretationComponent = ({ user, birthChartData }) => {
  return (
    <div className="bg-white/20 rounded-lg p-4">
      <FutureInterpretation user={user} birthChartData={birthChartData} />
    </div>
  );
};

// Default export (webpack uyumluluğu için)
export default {
  getPlanetsData,
  getHousesData,
  zodiacIconMap,
  TabButton,
  MainTabButton,
  TabContainer,
  MainTabContainer,
  PlanetList,
  HouseList,
  HouseModal,
  BirthChartComponent,
  FutureInterpretationComponent
};
